<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item :label="$t('订单状态')">
      <a-select
        style="width: 100%"
        v-model="form.data.status">
        <a-select-option
          v-for="item in orderStatus"
          :key="item.code"
          :value="item.code">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="orderId" @click="onConfirm">{{ $t('CONFIRM') || '确定' }}</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { _cancelOrder, _queryOrder, _unShippedOrder } from '@/api/orderApi';

async function getOrderDetail() {
  const result = await _queryOrder(this.orderId);
  if (result) {
    this.form.data.status = result.status;
  }
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

async function onConfirm() {
  if (this.form.data.status === 'UN_PAID') {
    if (this.onSubmitHandler) {
      this.onSubmitHandler();
    }
  } else if (this.form.data.status === 'UN_SHIPPED') {
    this.$refs.form.validate(async (valid) => {
      if (valid) {
        const result = await _unShippedOrder(this.orderId);
        if (result) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          if (this.onSubmitHandler) {
            this.onSubmitHandler();
          }
        }
      }
    });
  } else if (this.form.data.status === 'CANCEL') {
    this.$refs.form.validate(async (valid) => {
      if (valid) {
        const result = await _cancelOrder(this.orderId);
        if (result) {
          this.$message.success('取消成功');
          if (this.onSubmitHandler) {
            this.onSubmitHandler();
          }
        }
      }
    });
  }
}

export default {
  name: 'OrderStatusEdit',
  components: {},
  props: {
    orderId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
    onConfirmHandler: Function,
  },
  watch: {
    orderId() {
      if (this.orderId) {
        this.getOrderDetail();
      }
    },
  },
  methods: {
    onCancel,
    onConfirm,
    getOrderDetail,
  },
  data() {
    return {
      orderStatus: [
        {
          code: 'UN_PAID',
          name: '未支付',
        },
        {
          code: 'UN_SHIPPED',
          name: '已支付,待发货',
        },
        {
          code: 'CANCEL',
          name: '取消',
        }
      ],
      form: {
        data: {
          orderId: '',
          status: 'UN_PAID',
        },
        rules: {},
        title: '',
      },
    };
  },
  created() {
    if (this.orderId) {
      this.getOrderDetail();
    }
  },
};
</script>
